import moment from 'moment-timezone';

export default () => (time, zone) => {
  const tzTime = moment.tz(time, zone);
  const formatted = moment(tzTime._d).format('YYYY-MM-DD HH:mm:ss');
  return moment(formatted).fromNow();
};
